export enum LoginOptionsEnum {
  Code = 'code',
  Password = 'pwd',
}
